<!-- 分享的文件夹内容 -->
<template>
  <div class="shareFolder">
    <!-- 面包屑 -->
    <ul class="breadcrumb">
      <li v-for="(item, index) in navList" :key="index" :class="{ navActive: item.folderId === currentFolderId }" @click="clickBread(item, index)">
        {{ item.folderName }}
        <span v-if="index !== navList.length - 1" style="padding: 0px 6px">/</span>
      </li>
    </ul>
    <!-- 文档列表 -->
    <van-pull-refresh v-model="refreshing" v-loading="loading" class="folderList" @refresh="onRefresh">
      <div v-for="item in myDocList" :key="item.folderId" class="folderItem" @click="nextDetails(item)">
        <oneFileFolder :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneFileFolder>
      </div>
      <div v-if="!myDocList.length" class="empty">暂无数据</div>
    </van-pull-refresh>

    <!-- 更多弹框 -->
    <shareFolderMore ref="shareFolderMore" :rootPrjId="rootPrjId" @toRefresh="toRefresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import docService from "@/CommonDP/service/doc-service";
import oneFileFolder from "../../../components/oneFileFolder.vue";
import shareFolderMore from "./shareFolderMore.vue";

export default {
  components: { oneFileFolder, shareFolderMore },
  data() {
    return {
      navList: [], // 展开路径
      currentFolderId: "", // 当前打开的文件夹
      rootPrjId: "",
      myDocList: [], // 我的文档列表
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {},
  methods: {
    // 获得我的文档列表_初始化
    async getDocList_init(rootFolder) {
      const { folderId, folderName, prjId } = rootFolder;
      this.currentFolderId = folderId || "";
      this.rootPrjId = prjId || "";
      // 设置展开路径
      this.navList = [];
      const nav = { folderId, folderName };
      this.navList.push(nav);
      this.getDocList(folderId);
    },
    // 获得我的文档列表
    async getDocList(folderId) {
      this.loading = true;
      try {
        const params = {
          folderId,
          prjId: this.rootPrjId,
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          versionId: ""
        };
        const res = await docService.queryTree(params);
        this.myDocList = res.data || [];
        this.currentFolderId = folderId || "";
      } finally {
        this.loading = false;
      }
    },

    // 刷新列表
    toRefresh() {
      this.getDocList(this.currentFolderId);
    },
    // 点击路径
    clickBread(item, index) {
      this.navList = this.navList.slice(0, index + 1);
      this.getDocList(item.folderId);
    },
    // 下拉刷新
    async onRefresh() {
      try {
        const folderId = this.currentFolderId;
        await this.getDocList(folderId);
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(function (item) {
      if (item.isFolder === 1) {
        this.navList.push(item);
        this.getDocList(item.folderId);
      } else {
        // 预览文件
        if (item.isDelete === 1) {
          return Notify({ type: "warning", message: "该文件已删除，无法查看" });
        }
        const value = {
          fileId: item.folderId,
          versionId: item.fileVersion,
          fileType: item.fileType,
          noNeedIssue: "true"
        };
        viewAppFileMethods(item, value);
      }
    }),

    // 点击... 打开更多
    moreOpen(item) {
      if (item.isFolder === 1) {
        this.$refs.shareFolderMore.setFolderPrivi(item);
      } else {
        this.$refs.shareFolderMore.setFilePrivi(item);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.shareFolder {
  width: 100%;
  height: 100%;

  .breadcrumb {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    white-space: nowrap;
    background-color: #ffffff;
    border-bottom: 1px solid #e5e8f1;
    overflow: auto;

    li {
      list-style: none;
      display: inline-block;
      color: #006dfe;
      font-size: 14px;
    }

    .navActive {
      color: var(--key-color);
    }
  }

  .folderList {
    width: 100%;
    height: calc(100% - 32px);
    overflow-y: auto;
    .empty {
      width: 100%;
      height: calc(100% - 66px);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--info-color)9;
      font-size: 16px;
    }
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
